import { useState } from 'react';
import {removeError} from "../_store/_actions/uiActions";
import { useDispatch } from 'react-redux';

export const useForm = ( initialState = {} ) => {
    const dispatch = useDispatch();
    const [values, setValues] = useState(initialState);

    const reset = () => {
        setValues( initialState );
    }

    const handleInputChange = ({ target }) => {
        dispatch(removeError());
        setValues({
            ...values,
            [ target.name ]: target.value
        });
    }

    return [ values, handleInputChange, reset ];
}